import i18n from "../../i18n";
import paginationStyles from "./pagination.module.css";

const VISIBLE_PAGES_COUNT = 6;

function Pagination({
  items,
  activeIndex,
  onClick,
  itemsPerSlide = 1, // number of items per slide
}: {
  items: any[];
  activeIndex: number; // this is the **slide index**
  onClick: (slideIndex: number) => void;
  itemsPerSlide?: number;
}) {
  const totalPages = Math.ceil(items.length / itemsPerSlide); // total slides

  if (totalPages <= VISIBLE_PAGES_COUNT) {
    return (
      <ul dir={i18n.dir()} className={paginationStyles.pagination}>
        {Array.from({ length: totalPages }, (_, index) => (
          <li
            key={index}
            className={`${paginationStyles.page} ${
              index === activeIndex && paginationStyles.page_active
            }`}
            onClick={() => onClick(index)}
          />
        ))}
      </ul>
    );
  }

  let start = Math.max(0, activeIndex - Math.floor(VISIBLE_PAGES_COUNT / 2));
  start = Math.min(start, totalPages - VISIBLE_PAGES_COUNT);

  const visibleItemsIndexes = Array.from(
    { length: VISIBLE_PAGES_COUNT },
    (_, i) => start + i
  );

  const hasMoreBefore = start > 0;
  const hasMoreAfter = start + VISIBLE_PAGES_COUNT < totalPages;

  const handlePageClick = (pageIndex: number, isFirst: boolean, isLast: boolean) => {
    if (isFirst && hasMoreBefore) {
      onClick(0);
      return;
    }
    if (isLast && hasMoreAfter) {
      onClick(totalPages - 1);
      return;
    }
    onClick(pageIndex);
  };

  return (
    <ul className={paginationStyles.pagination}>
      {visibleItemsIndexes.map((pageIndex, indexInSlice) => {
        const isFirstVisible = indexInSlice === 0;
        const isLastVisible = indexInSlice === VISIBLE_PAGES_COUNT - 1;

        const classNames = [paginationStyles.page];
        if (pageIndex === activeIndex) classNames.push(paginationStyles.page_active);
        if (isFirstVisible && hasMoreBefore) classNames.push(paginationStyles.page_small);
        if (isLastVisible && hasMoreAfter) classNames.push(paginationStyles.page_small);

        return (
          <li
            key={pageIndex}
            className={classNames.join(" ")}
            onClick={() => handlePageClick(pageIndex, isFirstVisible, isLastVisible)}
          />
        );
      })}
    </ul>
  );
}

export default Pagination;
